import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText from '../../../../Core/RichText';
import ProductIconText from '../../../Optimum/OptimumProductCards/ProductIconText';
import Pills from '../../../../Core/Pills';
import Ctas from '../../../../Core/Ctas';
import { InterestRates } from '../../../TitleImageWithIconList';
import StatementSection from '../../../StatementSection';

import {
  Block,
  Content,
  ImageWrapper,
  Img,
  Header,
  CardName,
  CardDescription,
  CtaSection,
  CardTitle,
} from './styles';

export const headingSection = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <CardName>{children}</CardName>,
  },
};

export const subHeading = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => (
      <CardDescription>{children}</CardDescription>
    ),
  },
};

const body = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => {
      return <>{children}</>;
    },
    [BLOCKS.EMBEDDED_ENTRY]: node => {
      const { data } = node;
      if (data.target.component === 'interest-rates') {
        return <InterestRates data={data.target} className="card-comparison" />;
      } else if (
        data.target.__typename === 'ContentfulTitleOrImageWithIconLists'
      ) {
        return (
          <ProductIconText data={data.target} className="card-comparison" />
        );
      } else if (data.target.component === 'title-with-statement') {
        return (
          <StatementSection data={data.target} className="card-comparison" />
        );
      }
      return null;
    },
  },
};

const CardDetails = ({ data, isOpen }) => {
  if (!data) return null;

  const {
    heading,
    imageDam,
    bodyCopy,
    subhead,
    pillText,
    pillTextColor,
    pillBackgroundColor,
    ctas,
  } = data;

  return (
    <Block isOpen={isOpen}>
      <Header>
        <div>
          {pillText && (
            <Pills
              backgroundColor={pillBackgroundColor}
              textColor={pillTextColor}
            >
              {pillText}
            </Pills>
          )}
        </div>
        <div>
          {imageDam && (
            <ImageWrapper>
              <Img src={imageDam} alt={imageDam.altText || ''} />
            </ImageWrapper>
          )}
        </div>

        <CardTitle>
          {heading && <RichText document={heading} options={headingSection} />}
          {subhead && <RichText document={subhead} options={subHeading} />}
        </CardTitle>
      </Header>
      <Content>
        {bodyCopy && <RichText document={bodyCopy} options={body} />}
      </Content>
      <CtaSection>{ctas && <Ctas ctas={ctas} />}</CtaSection>
    </Block>
  );
};

CardDetails.propTypes = {
  data: PropTypes.shape().isRequired,
  isOpen: PropTypes.bool,
};

export default CardDetails;
